import { Field } from "@/components/Field";
import { Input } from "@/components/ui/input";
import { clientsApi } from "@/api/directory";
import { DirectoryFormPage } from "./DirectoryFormPage";
import { CLIENT_STATUSES } from "./statuses";

const BLANK_CLIENT = {
  first_name: "",
  last_name: "",
  date_of_birth: "",
  status: "prospective",
  phone: "",
  email: "",
  address_line1: "",
  address_line2: "",
  city: "",
  state: "",
  postal_code: "",
};

function clientFields({ values, handleChange, fieldErrors }) {
  return (
    <Field label="Date of birth" name="date_of_birth" error={fieldErrors.date_of_birth}>
      {(props) => (
        <Input
          {...props}
          type="date"
          value={values.date_of_birth}
          onChange={handleChange}
          required
        />
      )}
    </Field>
  );
}

export function ClientFormPage() {
  return (
    <DirectoryFormPage
      resource={clientsApi}
      statuses={CLIENT_STATUSES}
      blankValues={BLANK_CLIENT}
      basePath="/clients"
      listLabel="Clients"
      newTitle="New client"
      extraFields={clientFields}
      statusHint="Set a client who has left care to Discharged; client records are kept, not deleted."
    />
  );
}
